<template>
  <b-modal
    ref="modal-abrircard"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione as informações de quadro, board e origem onde sera gerado os
      cards
    </template>

    <section class="create__card__container pb-4">
      <div>
        <SelectBoard @onSelect="loadColumns" :onlyActive="true" />
      </div>
      <div>
        <SelectBoardColumn
          v-if="createCard.boardId"
          @onSelect="saveBoardAndColumn"
          :boardId="createCard.boardId"
          :key="createCard.boardId"
        />
      </div>
      <div>
        <SelectOrigem v-if="createCard.boardColumnId" @onSelect="saveOrigin" />
      </div>
    </section>

    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="confirmSelection"
      icon="fas fa-check-circle"
      text="Salvar"
    />
  </b-modal>
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'

const AcaoListaInteligenteData = {
  boardColumnId: null,
  origemLeadId: null,
  acaoListaInteligente: 'OPEN_CARD'
}

export default {
  name: 'AbrirCardModal',
  components: {
    DefaultButton,
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      acaoListaId: null,
      createCard: {
        boardId: null,
        boardColumnId: null,
        originId: null
      }
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.$refs['modal-abrircard'].show()
      }
    },
    hideModal () {
      this.$refs['modal-abrircard'].hide()
    },
    loadColumns (boardId) {
      this.createCard.boardId = boardId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.createCard.boardId = boardAndColumn[0]
      this.createCard.boardColumnId = boardAndColumn[1]
    },
    saveOrigin (origin) {
      this.createCard.originId = origin
    },
    checkFieldsCreateCard () {
      if (this.createCard.boardId && this.createCard.boardColumnId && this.createCard.originId) return true
      else {
        toast.warning('Todos os campos devem estar preenchidos', 'Criar oportunidades')
        return false
      }
    },
    confirmSelection () {
      if (this.checkFieldsCreateCard) {
        loading.push()
        this.data.boardColumnId = this.createCard.boardColumnId
        this.data.origemLeadId = this.createCard.originId
        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/OpenCardModal.vue